export default class CustomError extends Error {
  addToTopOfStackTrace(message: string) {
    if (!this.stack) {
      this.stack = message;
    } else {
      const pieces = this.stack.split("\n");

      const mainMessage = pieces[0];
      const restStack = pieces.slice(1);

      this.stack = [mainMessage, `\t${message}`, ...restStack].join("\n");
    }
  }
}
